import { render, staticRenderFns } from "./OrdersForDelivery.vue?vue&type=template&id=bc34a262&scoped=true"
import script from "./OrdersForDelivery.vue?vue&type=script&lang=js"
export * from "./OrdersForDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc34a262",
  null
  
)

export default component.exports